<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <referral-commission-table></referral-commission-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import ReferralCommissionTable from './ReferralCommissionTable.vue'

  export default {
    name: 'referral-commission-table-view',
    components: {ReferralCommissionTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/promotion/referralCommission/ReferralCommission.vue